export default function FichaTecnica(){
    return <div>Ficha Técnica</div>;
}